import React, { useEffect, useRef, useState } from 'react';

import ContractTopbar from './ContractTopbar';

import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import ResourceService from '../../service/ResourceService';


export const ContractDetail = (props) => {
    const { t } = useTranslation();
    const toast = useRef(null);
    const navigate = useNavigate();



    const [contract, setContract] = useState("");
    let { resourceCode } = useParams();


    useEffect(() => {
        loadContract();
    }, []);



    const loadContract = async () => {
        setContract();
        ResourceService.inquireResource(resourceCode ? resourceCode : props.resourceCode).then(
            (response) => {
                console.log("inquireResource", response)
                console.log("inquireResource", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireResource", response?.data?.data?.dataList)
                    setContract(response?.data?.data?.dataList[0].value);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireResource logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }




    return (


        <div style={{ padding: '1.5rem 2rem', marginBottom: '2rem' }}>
            <div dangerouslySetInnerHTML={{ __html: contract }} />
        </div>

    );
};

